module.exports = __webpack_public_path__ + "static/media/marufJU.96adcea5.jpg";